// src/firebase/chat.js
import {
  collection, serverTimestamp, query, limit, orderBy, addDoc, onSnapshot
} from 'firebase/firestore';
import {
  ref, onValue, push, serverTimestamp as rtServerTimestamp, remove, query as rtQuery, limitToLast
} from 'firebase/database';
import { db, rtdb, auth } from './index';

// ─── Room Chat (RTDB) ──────────────────────────────────────────────────────

export const sendChatMessage = async (roomId, userId, playerName, text, type = 'chat') => {
  const chatRef = ref(rtdb, `chat/${roomId}`);
  await push(chatRef, {
    userId,
    playerName,
    text,
    type,   // chat | correct | system | hint
    time: rtServerTimestamp(),
  });
};

export const sendSystemMessage = async (roomId, text) => {
  const chatRef = ref(rtdb, `chat/${roomId}`);
  await push(chatRef, {
    userId: 'system',
    playerName: 'System',
    text,
    type: 'system',
    time: rtServerTimestamp(),
  });
};

export const listenChat = (roomId, callback) => {
  // Only the newest 100 messages are ever delivered, so don't download the rest.
  const chatQuery = rtQuery(ref(rtdb, `chat/${roomId}`), limitToLast(100));
  const unsubscribe = onValue(chatQuery, (snap) => {
    const val = snap.val();
    if (val) {
      const messages = Object.entries(val).map(([id, msg]) => ({ id, ...msg }));
      callback(messages.slice(-100)); // keep last 100
    } else {
      callback([]);
    }
  });
  return unsubscribe;
};

export const clearChat = async (roomId) => {
  await remove(ref(rtdb, `chat/${roomId}`));
};

// ─── Global Chat (Firestore) ───────────────────────────────────────────────

export const sendGlobalMessage = async (userId, playerName, text) => {
  if (!userId || !text?.trim()) return;
  // Anonymous users cannot post to Global Chat (Firestore rules also block it)
  if (auth.currentUser?.isAnonymous) return;
  await addDoc(collection(db, 'globalChat'), {
    userId,
    name: playerName,
    text: text.trim(),
    timestamp: serverTimestamp(),
  });
};

export const listenGlobalChat = (callback, onError) => {
  const q = query(
    collection(db, 'globalChat'),
    orderBy('timestamp', 'desc'),
    limit(80)
  );
  return onSnapshot(q, (snap) => {
    const msgs = snap.docs
      .map(d => ({ id: d.id, ...d.data() }))
      .reverse();
    callback(msgs);
  }, onError);
};
